import { patchRangeCloneContents } from "./patchRangeCloneContents.js";
export function withRangeCloneContentsPatched(callback) {
  const undo = patchRangeCloneContents();
  try {
    callback();
  } finally {
    undo();
  }
}